import styled from "styled-components";

export const MainSection = styled.section`
  /* margin-top: 0rem;
  padding-bottom: 6rem; */
  overflow: hidden;
  background: #032b88;
  .container {
    margin-top: 6rem;
    padding-bottom: 4rem;
  }

  .btn-div {
    margin-top: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  /* background: linear-gradient(#008bda, #a100d5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; */
  color: #fff;
  text-align: center;
  padding-top: 2rem;
`;

export const MainWrapper = styled.div`
  position: relative;
  margin-top: 6rem;

  @media (max-width: 991.98px) {
    display: none;
  }
`;

export const TextDiv = styled.div`
  position: absolute;

  /* top: 90px;
  left: 33%; */
  &.first-div {
    top: 0px;
    left: 12%;

    @media (max-width: 1399.98px) {
      left: 12%;
    }

    @media (max-width: 1199.98px) {
      top: -2rem;
    }
  }

  &.second-div {
    top: 390px;
    left: 30%;

    @media (max-width: 1399.98px) {
      top: 310px;
    }

    @media (max-width: 1199.98px) {
      top: 230px;
    }
  }

  &.third-div {
    top: 0px;
    left: 49%;

    @media (max-width: 1199.98px) {
      top: -2rem;
    }
  }

  &.fourth-div {
    top: 390px;
    left: 67.5%;

    @media (max-width: 1399.98px) {
      top: 310px;
    }

    @media (max-width: 1199.98px) {
      top: 230px;
    }
  }

  &.fifth-div {
    top: 0px;
    left: 85%;

    @media (max-width: 1199.98px) {
      top: -2rem;
    }
  }
`;

export const HeaderTitle = styled.h5`
  /* color: #032b88; */
  color: #fff;
  font-size: 1.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
`;

export const Text = styled.p`
  /* color: var(--a, #4d4d4d); */
  color: #fff;
  font-family: "Catamaran";
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
  text-transform: capitalize;
  width: 19rem;
  white-space: pre-line;
  margin-top: 0.15rem;
  margin-bottom: 0rem;
  @media (max-width: 575.98px) {
    width: 100%;
  }
`;

export const ResponsiveRoadmapWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin-top: 4rem;

  img {
    width: 349px;

    @media (max-width: 767.98px) {
      width: 250px;
    }
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

export const MobileTextDiv = styled.div`
  position: absolute;

  &.first-div {
    top: 20px;
    left: 55%;

    @media (max-width: 767.98px) {
      top: 0px;
      left: 55%;
    }

    @media (max-width: 575.98px) {
      top: 80px;
      left: 20%;
    }
  }

  &.second-div {
    top: 420px;
    left: 55%;

    @media (max-width: 767.98px) {
      top: 280px;
      left: 55%;
    }

    @media (max-width: 575.98px) {
      top: 400px;
      left: 20%;
    }
  }

  &.third-div {
    top: 850px;
    left: 55%;

    @media (max-width: 767.98px) {
      top: 600px;
      left: 55%;
    }

    @media (max-width: 575.98px) {
      top: 700px;
      left: 20%;
    }
  }

  &.fourth-div {
    top: 1250px;
    left: 55%;

    @media (max-width: 767.98px) {
      top: 900px;
      left: 55%;
    }

    @media (max-width: 575.98px) {
      top: 1000px;
      left: 20%;
    }
  }

  &.fifth-div {
    top: 1720px;
    left: 55%;

    @media (max-width: 767.98px) {
      top: 1220px;
      left: 55%;
    }

    @media (max-width: 575.98px) {
      top: 1300px;
      left: 20%;
    }
  }
`;

export const ImgWrapper = styled.div`
  text-align: center;
`;

export const GitBookBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #fff;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 21.6642px;
  text-transform: capitalize;
  padding: 0.2em 1.5em;
  /* border-radius: 4px; */
  border: none;
  cursor: pointer;
  margin-top: 2rem;
  color: #032b88;
  background: linear-gradient(90.41deg, #fff 0.34%, #fff 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
  margin-top: 6rem;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }
`;
